import Timeout from "await-timeout";
import { Item } from "../../typings/miro";
import config from "../../config";

// Takes Miro board items returned form a Miro function and puts a shim in the "sync" call so they pass though this as well
export function convertToSafeSync(item: Item & { _sync?(): Promise<void> }) {
  if (item?._sync) {
    return item;
  } else if (item) {
    item._sync = item.sync;
    item.sync = async (): Promise<void> => {
      // if (item.type === "image" || item.type === "embed") {
      //     await seconds(3);
      // } else {
      //     await seconds(.3);
      // }

      //@ts-ignore
      return await miroLimit(item._sync());
    };
  }
}

const board = miro.board as any;
type oneOrMany = "one" | "many"

export const propertiesToReplace: { name: string, returns?: oneOrMany, sends?: oneOrMany }[] = [
  { name: "createCard", returns: "one" },
  { name: "createAppCard", returns: "one" },
  { name: "createFrame", returns: "one" },
  { name: "createImage", returns: "one" },
  { name: "createPreview", returns: "one" },
  { name: "createShape", returns: "one" },
  { name: "createStickyNote", returns: "one" },
  { name: "createText", returns: "one" },
  { name: "createEmbed", returns: "one" },
  { name: "createTag", returns: "one" },

  { name: "sync", sends: "one" },
  { name: "remove", sends: "one" },

  { name: "bringToFront", sends: "many" },
  { name: "sendToBack", sends: "many" },

  { name: "getById", returns: "many" },
  { name: "get", returns: "many" },

  { name: "getInfo" },
  { name: "getUserInfo" },

  { name: "getSelection", returns: "many" },

  { name: "getAppData" },
  { name: "setAppData" },
  { name: "getIdToken" },
];

// Add shim
for (const prop of propertiesToReplace) {
  const name = prop.name;
  const _name = "_" + name;
  if (board[_name] === undefined) {
    board[_name] = board[name];
    board[name] = async (a?: any, b?: any) => {
      // Put a general timeout in this call to prevent lockups
      const result = await Timeout.wrap(
        board[_name](a, b),
        config.miroCallTimeoutMs,
        "Timeout " + name
      );
      if (prop.returns === 'many') {
        for (const item of result) {
          convertToSafeSync(item);
        }
      }
      if (prop.returns === 'one') {
        convertToSafeSync(result);
      }
      return result;
    };
  }
}

export function miroApiShim() { }

export const miroLimit = (function () {
  let lastErrorWhen: number;

  return (incomingPromise: Promise<any>) => {
    return new Promise<number>((resolve, reject) => {
      const timer = new Timeout();
      timer.set(config.miroCallTimeoutMs).then(() => {
        reject("Miro Timeout");
      });

      incomingPromise.then((result) => {
        timer.clear();
        resolve(result);
      });

      incomingPromise.catch((error) => {
        console.error("caught:", error);
        timer.clear();
        if (error.toString().includes("API rate limit was exceeded")) {
          // Blow away all remaining transactions and don't throw the error again
          if (
            lastErrorWhen === undefined ||
            Date.now() > lastErrorWhen + 1000
          ) {
            if (error.toString().includes("per hour")) {
              alert(
                "Miro has limited the number of transactions an app can perform in an hour. Please wait an hour before taking more actions through the app. You can re-set the limit by refreshing the browser window"
              );
            } else {
              alert(
                "Miro has limited the number of transactions an app can perform. Please wait one minute before taking more actions through the app."
              );
            }
            lastErrorWhen = Date.now();
          }
        }
        reject(error);
      });
    });
  };
})();
